import React,{useState} from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import InvData2 from './InvData2';
import InvAlarmas from './InvAlarmas';
import './VerInv.css';

function VerInv(){
    const [nombreInv,setNombreInv] = useState();
    const params = useParams();
    const { ct, inv } = params;

    const childToParent = (nombreInv) => {
        setNombreInv(nombreInv)
        }

    /*Sirve para que las llamadas no se acumulen al cambiar de ventana  */
    var [code, setCode] = useState(null);
    if(code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor);
    }

    /*window.addEventListener("orientationchange", function(){
        window.location.reload();
        });*/

    return (
        <div className='div-tabs-inv'>
            <h3>{nombreInv}</h3>
            <Tabs defaultActiveKey="general">
                <Tab eventKey="general" title="General">
                    <InvData2 childToParent={childToParent} code={code} ct={ct} inv={inv} />
                </Tab>
                <Tab eventKey="alarmas" title="Alarmas">
                    <InvAlarmas code={code} ct={ct} inv={inv}/>
                </Tab>
            </Tabs>
        </div>
    );
};

export default VerInv;